export const SET_CARDHOLDERINFO = 'set_cardholderinfo';
export const RESET_CARDHOLDERINFO = 'reset_cardholderinfo';
